import { c as _c } from "react/compiler-runtime";
import type { OnboardingRequirementCollectDocument } from '@onefootprint/request-types';
import PhotoCapture from '../../../components/photo-capture/photo-capture';
import type { ReceivedImagePayload } from '../../../types';
import DesktopCameraPermission from './desktop-camera-permission';
import type { CameraPermissionState } from './use-camera-permission';
const FACE_OUTLINE_TO_WIDTH_RATIO = 0.7;
type DesktopSelfieViewProps = {
  permissionState: CameraPermissionState;
  cameraTitleCamera: string;
  cameraTitlePreview: string;
  cameraSubtitleCamera: string;
  requirement: OnboardingRequirementCollectDocument;
  hasBadConnectivity: boolean | undefined;
  allowPdf: boolean;
  onComplete: (payload: ReceivedImagePayload) => void;
  onCameraStuck: () => void;
};
const DesktopSelfieView = t0 => {
  const $ = _c(10);
  const {
    permissionState,
    cameraTitleCamera,
    cameraTitlePreview,
    cameraSubtitleCamera,
    requirement,
    hasBadConnectivity,
    allowPdf,
    onComplete,
    onCameraStuck
  } = t0;
  let t1;
  if ($[0] !== allowPdf || $[1] !== cameraSubtitleCamera || $[2] !== cameraTitleCamera || $[3] !== cameraTitlePreview || $[4] !== hasBadConnectivity || $[5] !== onCameraStuck || $[6] !== onComplete || $[7] !== permissionState || $[8] !== requirement) {
    t1 = permissionState === "allowed" ? <PhotoCapture autocaptureKind="face" cameraKind="front" deviceKind="desktop" allowPdf={allowPdf} requirement={requirement} hasBadConnectivity={hasBadConnectivity} outlineHeightRatio={FACE_OUTLINE_TO_WIDTH_RATIO} outlineWidthRatio={FACE_OUTLINE_TO_WIDTH_RATIO} title={{
      camera: cameraTitleCamera,
      preview: cameraTitlePreview
    }} subtitle={{
      camera: cameraSubtitleCamera
    }} onComplete={onComplete} onCameraStuck={onCameraStuck} /> : <DesktopCameraPermission permissionState={permissionState} />;
    $[0] = allowPdf;
    $[1] = cameraSubtitleCamera;
    $[2] = cameraTitleCamera;
    $[3] = cameraTitlePreview;
    $[4] = hasBadConnectivity;
    $[5] = onCameraStuck;
    $[6] = onComplete;
    $[7] = permissionState;
    $[8] = requirement;
    $[9] = t1;
  } else {
    t1 = $[9];
  }
  return t1;
};
export default DesktopSelfieView;